export enum eQuestionStatus {
	"Todas" = 2,
	"Sin responder" = 0,
	"Respondidas" = 1,
}